import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ContactFormSheet } from "@/components/ContactFormSheet";
import { FeatureRequestSheet } from "@/components/FeatureRequestSheet";
import { AboutSheet } from "@/components/AboutSheet";
import { SocialShare } from "@/components/SocialShare";
import { useIsMobile } from "@/hooks/use-mobile";

export const FooterLinks = () => {
  const isMobile = useIsMobile();

  // On mobile, the menu is now integrated into the player's bottom row
  if (isMobile) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2">
        <AboutSheet className="text-foreground" />
        <Link to="/about">
          <Button
            variant="ghost"
            size="sm"
            className="glass-card hover:scale-105 smooth-transition w-full"
          >
            About & Roadmap
          </Button>
        </Link>
        <SocialShare className="text-foreground" />
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="glass-card hover:scale-105 smooth-transition group"
              onClick={() => window.open("https://buymeacoffee.com/skylofiatc", "_blank")}
            >
              <Heart className="h-4 w-4 mr-2 group-hover:text-red-500 transition-colors" />
              Donate
            </Button>
          </TooltipTrigger>
          <TooltipContent className="max-w-[200px]">
            Like the vibe? Help keep this site running with a small donation. Server costs for streaming aren't cheap,
            and your support keeps it free and ad-free for everyone. ✈️
          </TooltipContent>
        </Tooltip>
        <FeatureRequestSheet className="text-foreground" />
        <ContactFormSheet className="text-foreground" />
      </div>
    </TooltipProvider>
  );
};
